import React, { useEffect } from 'react';
import Graficos from './Graficos/Graficos';
import './home.css';


const Home = () => {

    return (
        <div className=''>
                <Graficos></Graficos>
        </div>
    )
}

export default Home